export const isValidQueryParams = queryString => {
  // Allow empty string or a valid query parameter string
  if (queryString === "" || queryString === null) return true;

  // Regular expression to validate query parameters
  const pattern = /^[a-zA-Z0-9_%-]+=[^&=]*(&[a-zA-Z0-9_%-]+=[^&=]*)*$/;

  // Check if the string is valid
  return pattern.test(queryString);
};
